// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "table" + "." + "a971720531b607f24efc" + ".css";
};